import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Modal, ModalFuss } from "./Modal.js";
export function useBestaetigung() {
    const [offen, setOffen] = useState(null);
    const offenRef = useRef(null);
    const antworten = useCallback((ja) => {
        const frage = offenRef.current;
        if (frage === null)
            return;
        offenRef.current = null;
        setOffen(null);
        frage.aufloesen(ja);
    }, []);
    const bestaetigen = useCallback((frage) => {
        if (offenRef.current !== null)
            return Promise.resolve(false);
        return new Promise((aufloesen) => {
            const eintrag = { ...frage, aufloesen };
            offenRef.current = eintrag;
            setOffen(eintrag);
        });
    }, []);
    // Aushängen mit offener Frage: abgelehnt — die Aktion, die sie schützte, ist ohnehin fort.
    useEffect(() => () => {
        const frage = offenRef.current;
        offenRef.current = null;
        frage?.aufloesen(false);
    }, []);
    const bestaetigung = offen === null ? null : createPortal(_jsx(Bestaetigung, { frage: offen, onAntwort: antworten }), document.body);
    return { bestaetigen, bestaetigung };
}
function Bestaetigung(p) {
    const gefaehrlich = p.frage.gefaehrlich === true;
    /*
     * Einstiegsfokus: bei der Gefahr-Frage auf „Abbrechen“, sonst auf den bestätigenden Knopf —
     * beides als `autoFocus` an `Knopf` (Attribut `anfangsfokus`, ModalFuss `gefahr` bzw. `aktionFokus`), den
     * me-dialog beim Öffnen vor dem ersten Feld bedient. Bis P8 setzte ein Effekt hier den
     * Fokus von Hand auf den nativen Knopf.
     */
    return (_jsxs(Modal, { titel: p.frage.titel, gestapelt: true, gefahr: gefaehrlich, onAbbrechen: () => p.onAntwort(false), children: [_jsx("div", { className: "ki-bestaetigung__text", children: typeof p.frage.text === "string"
                    ? _jsx("p", { className: "ki-rueckfrage__text", children: p.frage.text }) : p.frage.text }), _jsx(ModalFuss, { speichernText: p.frage.bestaetigenText, gefahr: gefaehrlich, aktionFokus: true, onSpeichern: () => p.onAntwort(true), onAbbrechen: () => p.onAntwort(false) })] }));
}
//# sourceMappingURL=useBestaetigung.js.map